<template>
  <value-container v-if="view_only" :value="date" :label="label" :md="md"/>
  <component :is='c_tag' :md4="md==4" :offset-md4="offset==4" :offset-md8="offset==8" v-else>
    <fs1-div><b>{{label || ''}}</b></fs1-div> 
    <v-menu
      ref="menu2"
      v-model="menu1"
      :close-on-content-click="false"
      :nudge-right="40"
        hide-details
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field
          :class="[required && (dateFormatted != null ? '': 'textEmpty')]"
          readonly
          :label="placeholder_label"
          v-model="dateFormatted"
          prepend-icon="event"
          hide-details
          @change="() => value = parseDate(dateFormatted)"
          v-on="on">
            <template v-slot:append>
              <div @click="clear" v-if="date">
                <v-icon style="cursor:pointer">clear</v-icon>
              </div>
            </template>
        </v-text-field>
      </template>
      <!-- :max="max" :min="min" -->
      <v-date-picker
      style="height: 380px;"
        :disabled="disabled"
        v-model="value"
        no-title
        @input="close"></v-date-picker>
    </v-menu>
  </component>
</template>

<script>
import inputs from '../mixins/inputs/inputs.js';
export default {
	mixins:[inputs],
  name:'in-calendar',
	props:{
		date: { default: null },
    placeholder_label:{},
    md:{},
    required:{default:false},
	},
  data() {
    return {
      value: null,
      dateFormatted: null,//this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
    };
  },
  computed: {
    computedDateFormatted () { return this.formatDate(this.date) },
  },
  watch: {
    value (v) {
      /* this.$emit('update:date', v); */
      this.dateFormatted = this.formatDate(v);
    },
    date (v) { this.value = v },
  },
  created() { this.value = this.date },
  methods: {
    close(v) {
      this.menu1 = false
      this.$emit('update:date', v)
    },
    formatDate (value) {
      if (!value) return null;
      if (isNaN(Date.parse(value))){
          this.setSnackbar({class:'error', message:'Formato fecha incorrecto'})
         return null;
      }
      // falta comparar fechas con el min y max
      const [year, month, day] = value.split('-')
      let res = null;
      try { res = `${day}/${month}/${year}` }
      catch (e) { this.setSnackbar({class:'error', message:'Formato fecha incorrecto'}) }
      return res;
    },
    parseDate (value) {
      if (!value) return null
      const [day, month, year] = value.split('/')
      let res = null;
      try { res = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}` }
      catch (e) { this.setSnackbar({class:'error', message:'Formato fecha incorrecto'}) }
      return res;
    },
    clear(){
      this.$emit('update:date', null)
    }
  }, // methods
};
</script>
